var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4465 16.5295C18.1868 16.5295 17.927 16.3968 17.7972 16.2642C17.1478 15.8662 17.018 15.0703 17.4076 14.407L20.1348 10.2946L17.4076 6.18223C17.018 5.51894 17.1478 4.723 17.7972 4.32502C18.4465 3.92705 19.2257 4.05971 19.6153 4.723L22.7321 9.63132C22.9918 10.0293 22.9918 10.6926 22.7321 11.0905L19.6153 15.9989C19.2257 16.3968 18.8361 16.5295 18.4465 16.5295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45999 16.5295C5.0704 16.5295 4.6808 16.2642 4.42107 15.8662L1.17441 11.0905C0.914681 10.6926 0.914681 10.0293 1.17441 9.63132L4.2912 4.723C4.6808 4.05971 5.45999 3.92705 6.10932 4.32502C6.75866 4.723 6.88852 5.51894 6.49892 6.18223L3.77173 10.2946L6.49892 14.407C6.88852 15.0703 6.75866 15.8662 6.10932 16.2642C5.97946 16.5295 5.71973 16.5295 5.45999 16.5295Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0047 16.5295C9.87485 16.5295 9.61512 16.5295 9.48525 16.3969C8.83592 16.1315 8.44632 15.3356 8.83592 14.6723L12.7319 4.85567C12.9916 4.19238 13.7708 3.79441 14.4202 4.19238C15.0695 4.4577 15.4591 5.25364 15.0695 5.91693L11.1735 15.7336C11.0436 16.2642 10.5242 16.5295 10.0047 16.5295Z",
    fill: "#FFFF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.68353323.svg";
export { ForwardRef as ReactComponent };